import React from "react";

import Box from "../Box";

import styled from "styled-components";
import { CText } from "@carrefour/design-system-components-react";
import BaseDashboardCard from "../BaseDashboardCard";
import { VabType } from "../../types/operational";
import { Choice } from "../../types/commercial";
import { useTranslation } from "react-i18next";
import { formatPercentage } from "../../utils/numberUtils";

const Text = styled(CText)`
  font-family: system-ui;
`;
const TextCustom = styled(CText)<{ color: string }>`
  font-family: system-ui;
  color: ${(props) => props?.color};
`;
type VABCardProps = {
  title: string;
  controlData: VabType;
  options: Choice[];
  isUnavailable: boolean;
  messageError?: string;
  isLoading: boolean;
  openInformationModal: (title?: string) => void;
};

const BoxCustom = styled(Box)<{ gap: string }>`
  gap: ${(props) => props.gap};
  display: flex;
`;

const getColorText = (value: number): string => {
  if (value === -1) return "black";

  if (value > 97) {
    return "#33691E";
  } else if (value <= 97 && value > 94) {
    return "#CC4010";
  }

  return "#AA0D11";
};
const VABCard = ({
  title,
  controlData,
  options,
  ...res
}: VABCardProps) => {
  const taux = (controlData?.controlled / controlData?.toControl) * 100;
  const {t} =useTranslation();
  
  return (
    <BaseDashboardCard
      hasModal={true}
      title={title}
      size={"big"}
      importedDateTime={controlData?.importedDateTime}
      {...res}
    >
      <BoxCustom
        gap="1.5rem"
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        width={"100%"}
        py={1}
      >
        <BoxCustom
          gap={`0.5rem`}
          flexDirection={"column"}
          alignItems={"center"}
          width="100%"
          borderRadius={1}
          border={"1px solid #BDC7DA"}
        >
          <Box display={"flex"} alignItems={"center"} pt={1}>
            <Text size={"m"} tagStyle="p">
              {`${controlData?.controlled}/${controlData?.toControl} ${t('operationnel.traitees')}`}
            </Text>
          </Box>

          <Box display={"flex"} alignItems={"baseline"} py={"4px"} pt={[0, 0]}>
            <TextCustom
              color={getColorText(taux)}
              size={"m"}
              tagStyle="h1"
            >{`${formatPercentage(taux, "")}`}</TextCustom>
            <TextCustom
              color={getColorText(taux)}
              tagStyle="p"
            >{`%`}</TextCustom>
          </Box>

          <Box display={"flex"} alignItems={"center"} pb={2}>
            <Text size={"m"} tagStyle="p">
              {`${t('operationnel.source')} : PVR45`}
            </Text>
          </Box>
        </BoxCustom>
        {/* famille */}
      </BoxCustom>
    </BaseDashboardCard>
  );
};

export default VABCard;
